import React from 'react'
import { Link } from 'react-router-dom';

export default function AdminBilder() {
  console.log("Hello")
  return (
    <div></div>
  )
}
